var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"remove-wishlist",attrs:{"href":"javascript:;"},on:{"click":_vm.removeFavoriteItem}},[_c('i',{staticClass:"demo-icon icon-union-50"}),_vm._v("\n    "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }